import { render, staticRenderFns } from "./yellowTitle.vue?vue&type=template&id=8fd93872&scoped=true"
import script from "./yellowTitle.vue?vue&type=script&lang=js"
export * from "./yellowTitle.vue?vue&type=script&lang=js"
import style0 from "./yellowTitle.vue?vue&type=style&index=0&id=8fd93872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd93872",
  null
  
)

export default component.exports